import { destroy, get, getOne, post, put } from "../apis/httpClient";

export const pagingSlider = (params) => get('/api/v1/slider/paging',params)
export const detailSlider=(query)=>getOne(`/api/v1/slider/detail/${query}`)
export const updateSlider=(body)=>put(`/api/v1/slider/update`,body)
export const createSlider=(body)=>post(`/api/v1/slider/create`,body)
export const deleteSlider = (body) => destroy(`/api/v1/slider/delete`,body)